export default __webpack_public_path__ + "static/media/special-olympics-logo.26c96463.png";